import React, { MouseEventHandler } from "react";
import { ClipboardIcon } from "@heroicons/react/solid";
import { Button } from "components/ui";

interface OfferAuthOtpActionProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  label: string;
}

export const OfferAuthOtpPasteButton = ({
  onClick,
  label,
}: OfferAuthOtpActionProps) => (
  <Button
    type="unstyled"
    submit
    onClick={onClick}
    className="text-slate-500 border flex justify-center gap-2 font-bold items-center h-11 border-slate-200 shadow-md w-[101px] py-1 px-2 rounded-md overflow-hidden"
  >
    <ClipboardIcon className="h-5 w-5 shrink-0 text-slate-500 " />
    <span className="truncate">{label}</span>
  </Button>
);

export const OfferAuthOtpResendButton = ({
  onClick,
  label,
}: OfferAuthOtpActionProps) => (
  <Button
    type="unstyled"
    submit
    onClick={onClick}
    className="text-blue-500 border-none"
  >
    {label}
  </Button>
);
